import { PasswordValue } from './password.value';

export class PasswordValueDto {
    currentPassword: string;
    newPassword: string;

    constructor(data: PasswordValue) {
        this.currentPassword = data.currentPassword;
        this.newPassword = data.newPassword;
    }
}
